<template>
    <fieldset ref="focusObject" @focusout="hideContextMenu">
        <a v-if="isActive" href="#void" @click.prevent="showContextMenu" class="btn btn-sm btn-light" style="padding: 0 2px; margin-right: 6px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
            </svg>
        </a>
        <a v-if="canPreview" href="#void" @click.prevent="menuItemClick('preview', document, getType, isDocumentFormat)">{{fileName}}</a>
        <a v-else-if="cannotPreview && isDocumentFormat" href="#void" @click.prevent="menuItemClick('download', document, 'downloadFormatted')">{{fileName}}</a>
        <a v-else-if="cannotPreview" href="#void" @click.prevent="menuItemClick('download', document, 'view')">{{fileName}}</a>
        
        <span v-else>{{fileName}}</span>
        
        <div v-if="isActive" @mousedown="disableFocusOut = true" class="dropdown-menu" :class="{ show: isContextMenuVisible }" style="left:auto; top:auto;">
            <a class="dropdown-item" href="#void" @click.prevent="menuItemClick('download', document, 'download')">Orijinal Dosyayı İndir</a>
            <a v-if="hasSignedVersion" class="dropdown-item" href="#void" @click.prevent="menuItemClick('download', document, 'downloadSigned')">İmzalı Versiyonu İndir</a>
            <a v-if="hasFormattedVersion" class="dropdown-item" href="#void" @click.prevent="menuItemClick('download', document, 'downloadFormatted')">Excel Formatında İndir</a>
            <!-- <div v-if="isEYP || isOffice365 || isGoogleDocs" class="dropdown-divider"></div> -->
            <div v-if="isEYP" class="dropdown-divider"></div>
            <a v-if="isEYP" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'eyp')">EYP paketi görüntüle</a>
            <a v-if="isOffice" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'office')">Dokümanı görüntüle</a>
            <a v-if="isText" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'text')">Metin Belgesini görüntüle</a>
            <a v-if="isCode" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'code')">XML Dosyasını görüntüle</a>
            <a v-if="isPdf" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'pdf')">Dokümanı görüntüle</a>
            <a v-if="isImage" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'image')">Resmi görüntüle</a>
            <!-- <a v-if="isPdf && hasSignedVersion" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'pdf')">İmzalı PDF Dosyasını görüntüle</a> -->
            <!-- <a v-if="isOffice365" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'office365')">Office365 ile görüntüle</a>
            <a v-if="isGoogleDocs" class="dropdown-item" href="#void" @click.prevent="menuItemClick('preview', document, 'googleDocs')">Google Docs ile görüntüle</a> -->
        </div>
        <!-- <input type="text" ref="focusObject" id="focusObject" class="focus-object"  /> -->
    </fieldset>
</template>
<script>
export default {
    props: {
        document: {
            type: Object,
            required: true
        },
        isActive: {
            type: Boolean,
            default: true
        },
        isOnlineView: {
            type: Boolean,
            default: true
        },
        isDocumentFormat:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            isContextMenuVisible: false,
            disableFocusOut: false
        }
    },
    methods: {
        
        showContextMenu(){
            this.isContextMenuVisible = true;
        },
        hideContextMenu(){
            if(this.disableFocusOut) {
                this.disableFocusOut = false;
                return;
            }

            this.isContextMenuVisible = false;

            //var scp = this;
            //setTimeout(function(){ scp.isContextMenuVisible = false; }, 50);
        },
        menuItemClick(event, param1, param2, param3) {
            this.$emit(event, param1, param2, param3);
            this.isContextMenuVisible = false;
        }
    },
    computed: {
        canPreview(){
            console.log("isOnlineView:",this.isOnlineView)
            console.log("isActive:",this.isActive)
            console.log("getType:",this.getType)
            if(!this.isActive)
                return false;
            if(this.getType == '')
                return false;
            if(!this.isOnlineView){
                if(this.getType == 'office')
                    return false;
            }
            return true;
        },
        cannotPreview(){
            if(!this.isActive)
                return false;
            if(this.getType == '')
                return true;
            if(!this.isOnlineView){
                if(this.getType == 'office' )
                    return true;
            }
            return false;
        },
        getType(){
            if(this.isText && this.isDocumentFormat){
                return 'office'
            }
            if(this.isPdf)
                return 'pdf'
            if(this.isOffice)
                return 'office'
            if(this.isEYP)
                return 'eyp'
            if(this.isCode)
                return 'code'
            if(this.isText)
                return 'text'
            if(this.isImage)
                return 'image'
            return ''
        },
        fileName(){
            return this.document.FileName || this.document.UnsignedFile.FileName;
        },
        extension(){
            return this.fileName.split('.').reverse()[0].toLowerCase();
        },
        size(){
            return this.document?.Size || this.document.UnsignedFile?.Size || 0;
        },
        hasSignedVersion(){
            return !!this.document.SignedFile;
        },
        isEYP(){
            return this.document.SignatureFormat == 'EYP' || this.document.SignatureFormat == 'EYP2' || this.document.Extension == '.eyp' || ['eyp'].indexOf(this.extension) > -1;
        },
        isOffice(){
            if(this.isDocumentFormat && this.isText){
                return true
            }
            return ['xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx'].indexOf(this.extension) > -1;
        },
        isCode(){
            return ['xml'].indexOf(this.extension) > -1;
        },
        isText(){
            return ['txt'].indexOf(this.extension) > -1;
        },
        isPdf(){
            //return false;
            return ['pdf'].indexOf(this.extension) > -1 ;
            // Bu özellik şimdilik devre dışı. PDF'i iframe içinde görüntülemek istediğimizde dosya olarak indiriyor.
            //return this.extension == 'pdf';
        },
        isImage(){
            return this.size < 5 * 1024 * 1024
                && ['jpeg', 'jpg', 'png'].indexOf(this.extension) > -1;
        },
        isOffice365(){
            return this.size < 5 * 1024 * 1024
                && ['pdf', 'xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'pps', 'sldx', 'xps', 'txt', 'rtf'].indexOf(this.extension) > -1;
        },
        isGoogleDocs(){
            return this.size < 5 * 1024 * 1024
                && ['pdf', 'xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'pps', 'sldx', 'xps', 'txt', 'rtf', 'jpeg', 'jpg', 'png', 'gif', 'bmp', 'mpeg4', '3gpp', 'mov', 'avi', 'wmv', 'mpegps', 'flv', 'html', 'pages', 'ai', 'psd', 'tiff', 'dxf', 'svg', 'ttf', 'xps', 'zip', 'rar'].indexOf(this.extension) > -1;
        },
        hasFormattedVersion(){
            return this.isDocumentFormat && this.isText;
        }
    }
}
</script>
<style scoped>
.focus-object {
    width:0px;
    height: 0px;
    border:0;
    outline:none;
    opacity: 0;
    position: absolute;
}
.download-signed-button-container{
    width: 100% ;
    height: 35px;
    flex-direction: row;
}
.download-signed-button-container button{
    min-width: 100px;
}
.btn-info,.btn-outline-secondary, .btn-primary{
    font-size: small;
}
</style>